'use client';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

import { CONTAINER, MEDIA, SECTION_PADDING, SPACING, TYPOGRAPHY } from '../../designTokens';

export const StripContainer = styled(Box)(() => ({
  width: '100%',
  position: 'relative',
  boxSizing: 'border-box',
  overflow: 'hidden',
}));

export const StripContent = styled(Box)(() => ({
  maxWidth: CONTAINER.maxWidth,
  margin: '0 auto',
  padding: `${SECTION_PADDING.compact.desktop} ${CONTAINER.gutter}`,
  display: 'flex',
  flexDirection: 'column',
  [MEDIA.downSm]: {
    padding: `${SECTION_PADDING.compact.mobile} ${CONTAINER.gutterMobile}`,
  },
}));

export const SectionLabel = styled(Box)(() => ({
  margin: 0,
  fontSize: '0.875rem',
  fontWeight: 800,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  marginBottom: SPACING.md,
}));

export const Title = styled(Box)(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '2rem',
  lineHeight: 1.2,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.75rem',
  },
}));

export const TitleHighlight = styled('span')(() => ({
  display: 'inline',
}));

export const Subtitle = styled(Box)(() => ({
  ...TYPOGRAPHY.sectionSubtitle.desktop,
  lineHeight: 1.7,
  '& > *:last-child': {
    marginBottom: 0,
  },
}));

export const BodyText = styled(Box)(() => ({
  fontSize: '1.125rem',
  lineHeight: 1.8,
  '& p': {
    marginTop: 0,
    marginBottom: SPACING.xl,
  },
  '& > *:first-child': {
    marginTop: 0,
  },
  '& > *:last-child': {
    marginBottom: 0,
  },
}));

export const BannerImage = styled(Box)(() => ({
  width: '100%',
  overflow: 'hidden',
  '& img, & video': {
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'cover',
  },
}));
